import api from './api';

export interface DangKyOnlinePayload {
    tenBn: string;
    namSinh: number;
    sdt: string;
    diaChi: string;
    ngayDangKyKham: string; // ISO string
    lyDoDenKham: string;
    ghiChu?: string;
}

export const getDangKyOnlines = async (fromDate: string, toDate: string, name?: string) => {
    return api.get('/dangkyonline', {
        params: { fromDate, toDate, name }
    });
};

export const createDangKyOnline = async (data: DangKyOnlinePayload) => {
    return api.post('/dangkyonline', data);
};

export const toggleDangKyStatus = async (id: number) => {
    return api.put(`/dangkyonline/${id}/toggle-status`);
};

export const updateDangKyOnline = async (id: number, data: any) => {
    return api.put(`/dangkyonline/${id}`, data);
};

export const deleteDangKyOnline = async (id: number) => {
    return api.delete(`/dangkyonline/${id}`);
};
